import { render, staticRenderFns } from "./TextColorProperty.vue?vue&type=template&id=7f6eb406&"
import script from "./TextColorProperty.vue?vue&type=script&lang=js&"
export * from "./TextColorProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports